<section class="history-section">

  <div class="history-controls">
    <kendo-textbox class="history-search" [value]="searchTerm" (valueChange)="onSearch($event)"
      placeholder="Search by field, value, or user">
      <ng-template kendoTextBoxPrefix>
        <span class="k-icon k-font-icon k-i-search"></span>
      </ng-template>
      <ng-template kendoTextBoxSuffix *ngIf="searchTerm">
        <button kendoButton type="button" fillMode="flat" icon="close" (click)="clearSearch()"></button>
      </ng-template>
    </kendo-textbox>
    <div class="history-count">
      Showing {{ filteredRows.length }} of {{ totalChanges }}
    </div>
  </div>

  <kendo-grid *ngIf="filteredRows.length"
              class="history-grid"
              [data]="filteredRows"
              [sortable]="true"
              [height]="460">
    <kendo-grid-column field="fieldName" title="Field" [width]="160"></kendo-grid-column>
    <kendo-grid-column field="oldValue" title="Old Value" [width]="180">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="history-value history-value--old" [innerHTML]="dataItem.oldValue"></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="newValue" title="New Value" [width]="180">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="history-value history-value--new" [innerHTML]="dataItem.newValue"></span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="userName" title="Updated By" [width]="160"></kendo-grid-column>
    <kendo-grid-column field="modifiedDate" title="Updated On" [width]="180">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.modifiedDate | date: 'medium' }}
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div class="history-empty" *ngIf="!filteredRows.length">
    <span class="history-empty__icon k-icon k-font-icon k-i-information"></span>
    <div class="history-empty__title">No history found</div>
    <div class="history-empty__subtitle">Try adjusting your search or check back once updates have been made.</div>
  </div>
</section>
